import { attr } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const RenewalStatus = ApplicationRecord.extend({
  static: {
    jsonapiType: 'renewal_statuses',
  },
  attrs: {
    status: attr(),
    note: attr(),
    schoolId: attr(),
  },
})

export default RenewalStatus
